import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SummaryAwardProgramComponent } from './dashboard/summary-award-program/summary-award-program.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCard, MatCardContent, MatCardFooter } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { NgChartsModule } from 'ng2-charts';
import { SummaryCommissionReportsComponent } from './dashboard/summary-commission-reports/summary-commission-reports.component';
import { ReportsModule } from '@pages/shared/reports/reports.module';
import { SummarySalesComponent } from './dashboard/summary-sales/summary-sales.component';
import { SummaryContemplatedQuotasComponent } from './dashboard/summary-contemplated-quotas/summary-contemplated-quotas.component';

@NgModule({
  declarations: [
    HomeComponent,
    DashboardComponent,
    SummarySalesComponent,
    SummaryAwardProgramComponent,
    SummaryCommissionReportsComponent,
    SummaryContemplatedQuotasComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCard,
    MatCardContent,
    MatCardFooter,
    MatIcon,
    MatDivider,
    MatProgressSpinnerModule,
    NgChartsModule,
    ReportsModule,
  ],
  exports: [
    HomeComponent,
  ]
})
export class HomeModule { }
